import { isNumber } from '../utils/functions.js';

function diffNumericOptions(options, fields) {
    const elementOptions = this.options;
    let hasChanges = false;
    let value, field;
    for (let i = 0; i < fields.length; i++) {
        field = fields[i];
        value = options[field];
        if (isNumber(value) && elementOptions[field] !== value) {
            elementOptions[field] = value;
            hasChanges = true;
        }
    }
    return hasChanges;
}

export { diffNumericOptions };
